<send-digital-certificate *ngIf="showSendCertificate() && !isLoading"></send-digital-certificate>
<digital-certificate-status *ngIf="!showSendCertificate() && !isLoading" [status]="certificateStatus" (retrySendCertificate)="onRetrySendCertificate()"></digital-certificate-status>

